import { memo } from "react";
import { useTranslate } from "helpers";
import { Badge } from "ui/components/Badge";
import { CalculationVehicleDetailCardProps } from "./types";

const CalculationVehicleDetailCard: React.FC<
  CalculationVehicleDetailCardProps
> = (props) => {
  const { vehicleInfo } = props;
  const { t } = useTranslate();

  const isNew =
    vehicleInfo.kmTraveled == null || vehicleInfo.kmTraveled < 100;

  const specs = [
    {
      label: t("admin.calculation.price.detail.power"),
      value: `${vehicleInfo.maximumPowerKw}/${vehicleInfo.maximumPowerHp} KW/KS`,
    },
    {
      label: t("admin.calculation.price.detail.numberofdoors"),
      value: vehicleInfo.numberOfDoors,
    },
    {
      label: t("admin.calculation.price.detail.cylindercapacity"),
      value: `${vehicleInfo.cylinderCapacity} ccm³`,
    },
    {
      label: t("admin.calculation.price.detail.kilometers"),
      value: `${vehicleInfo.kmTraveled ?? 0} km`,
    },
    {
      label: t("admin.calculation.price.detail.transmission"),
      value: vehicleInfo.transmission,
    },
    {
      label: t("admin.calculation.price.detail.fueltype"),
      value: vehicleInfo.fuelType,
    },
  ];

  return (
    <div>
      {/* Slika vozila */}
      <div className="bg-slate-50 rounded-sm mb-4">
        <img
          src={vehicleInfo.vehicleImage ?? ""}
          alt=""
          className="w-full object-contain rounded-xs"
        />
      </div>

      {/* Naslov + osnovni podaci */}
      <h2 className="text-lg font-bold leading-tight text-slate-900 truncate">
        {vehicleInfo.vehicleManufacturerName} {vehicleInfo.vehicleModelName} {vehicleInfo.vehicleTypeName ? ` ${vehicleInfo.vehicleTypeName}` : ""}
      </h2>
      <p className="text-sm text-slate-600 mt-1">
        {vehicleInfo.fuelType} / {vehicleInfo.maximumPowerKw} kW (
        {vehicleInfo.maximumPowerHp} KS)
        {vehicleInfo.transmission ? ` / ${vehicleInfo.transmission}` : ""}
      </p>

      <div className="mt-2">
        <Badge
          text={isNew ? "NOVO VOZILO" : "RABLJENO VOZILO"}
          variant={isNew ? "info" : "warning"}
          height="small"
          showDot
        />
      </div>

      {/* Specifikacije */}
      <div className="mt-4 grid grid-cols-2 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
        {specs.map((spec, index) => (
          <div key={index} className="bg-slate-50 px-3 py-2.5 text-center">
            <div className="text-xs text-slate-500">{spec.label}</div>
            <div className="text-sm font-semibold text-slate-900">
              {spec.value}
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-slate-400 mt-3">
        {t("admin.calculation.price.detail.picture.info")}
      </p>
    </div>
  );
};

export default memo(CalculationVehicleDetailCard);
